import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import actions from '../CellphoneRecharge/ValuesRecharge/actions'
import { Select } from 'loyal-react'

class SelectValuesRecharge extends Component {
  constructor (props) {
    super(props)

    this.onChange = this.onChange.bind(this)
  }

  componentDidMount () {
    if (this.props.operatorKey && this.props.areaCode) {
      this.props.getValuesRecharge(this.props.operatorKey, this.props.areaCode)
    } else {
      this.props.clearValuesRecharge()
    }
  }

  componentDidUpdate (prevProps) {
    if (
      this.props.operatorKey &&
      this.props.areaCode &&
      (this.props.operatorKey !== prevProps.operatorKey ||
        this.props.areaCode !== prevProps.areaCode)
    ) {
      this.props.getValuesRecharge(this.props.operatorKey, this.props.areaCode)
    }
  }

  onChange (item) {
    var selectedItem = this.props.valuesRecharge.find(
      valueRecharge => valueRecharge.serviceId === item.value
    )

    this.props.onChangeValue(selectedItem)
  }

  render () {
    let source = this.props.selectSource || []
    let value = source.find(item => item.value === this.props.value)
    return (
      <Select
        id={this.props.id}
        label={this.props.label}
        className={this.props.className}
        displayValue='description'
        selectedValue='value'
        options={source}
        value={value}
        required={this.props.required}
        onChange={this.onChange}
      />
    )
  }
}

SelectValuesRecharge.propTypes = {
  valuesRecharge: PropTypes.array,
  areaCode: PropTypes.number.isRequired,
  operatorKey: PropTypes.string,
  value: PropTypes.string,
  selectSource: PropTypes.array,
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  getValuesRecharge: PropTypes.func,
  onChangeValue: PropTypes.func,
  clearValuesRecharge: PropTypes.func,
  required: PropTypes.bool
}

const handleFormatValue = (
  value,
  decimalCurrency,
  decimalPlaces,
  pointsName
) => {
  if (!isNaN(value)) {
    return `${parseFloat(value).toLocaleString('pt-br', {
      minimumFractionDigits: decimalCurrency || decimalPlaces,
      maximumFractionDigits: decimalCurrency || decimalPlaces
    })}  ${decimalCurrency ? '' : pointsName} `
  }
  return ''
}

const mapStateToProps = ({
  valuesRecharge,
  catalog: {
    currencyConfiguration: { pointsName, decimalPlaces }
  }
}) => {
  const source = valuesRecharge.map(item => ({
    description: `R$ ${handleFormatValue(
      item.rechargeValue,
      2,
      null,
      pointsName
    )} por ${handleFormatValue(
      item.pointsValue,
      null,
      decimalPlaces,
      pointsName
    )}`,
    value: item.serviceId
  }))

  return {
    valuesRecharge: valuesRecharge || [],
    selectSource: source || [],
    pointsName,
    decimalPlaces
  }
}

const mapDispatchToProps = dispatch => ({
  getValuesRecharge: (operatorKey, areaCode) => {
    return dispatch(actions.getValuesRecharge(operatorKey, areaCode))
  },
  clearValuesRecharge: () => {
    return dispatch(actions.clearAreaCodes())
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectValuesRecharge)



// WEBPACK FOOTER //
// ./src/features/SelectValuesRecharge/SelectValuesRecharge.js